import { render } from "./EditFrivilligProfile.vue?vue&type=template&id=1d0e1dfc"
import script from "./EditFrivilligProfile.vue?vue&type=script&lang=js"
export * from "./EditFrivilligProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__